<template>
  <div class="container page main">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-content">
        <!-- <div @click="openHerderImg()" class="item van-hairline--bottom">
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img  :src="this.userInfo.header_img">
            <van-icon name="arrow" />
          </div>
        </div> -->
        <!-- <van-popup v-model="show" position="bottom" round :style="{ height: '50%' }">
            <div class="avatarbox">
                <div class="title van-hairline--bottom">
                  <van-icon @click="show=false" name="cross" />
                  <div class="text">{{$t("setting.choose_avatar")}}</div>
                  <div class="btnok" @click="check()">{{$t("setting.ok")}}</div>
                </div>
                <div class="content">
                  <van-image
                      round
                      v-for="(item,index) in 185" :key="index"
                      @click="select_header_img('https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png')"
                      :class="{ 'choose': isActive ===  'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'}"
                      :src="'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'"
                  />
                </div>
            </div>
        </van-popup> -->
        <div class="item van-hairline--bottom" @click="toSetName()">
        <div class="left">{{$t("setting.real_name")}}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.name ? this.userInfo.name : this.$t("setting.no_setting")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetSex()">
        <div class="left">{{$t("setting.sex")}}</div>
        <div class="right">
          <span class="desc">{{this.userInfo.sex !== "0" ? this.userInfo.sex === "1" ? this.$t("setting.man") :this.$t("setting.female"): this.$t("setting.unkown")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
        <div class="item van-hairline--bottom" @click="toSetBank()">
        <div class="left">{{$t("withdraw.bind_account_title")}}</div>
        <div class="right">
          <span class="desc">{{this.isBank ? this.$t("setting.bindinged") :this.$t("setting.no")}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>

    <div v-if="accountRows.length" class="account-card">
      <div class="account-title">{{ $t("withdraw.bind_account_title") }}</div>
      <div class="account-row" v-for="row in accountRows" :key="row.key">
        <div class="account-label">{{ row.title }}</div>
        <div class="account-value">{{ row.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  describeWithdrawInfo,
  parseWithdrawInfo,
  resolveWithdrawConfig,
  resolveWithdrawFields
} from '@/common/withdrawForm';

export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{},
      withdrawFields: [],
      accountInfo: {}
    };
  },
  computed: {
    accountRows() {
      return describeWithdrawInfo(this.withdrawFields, this.accountInfo);
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'post',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          this.isBank = !!(config.is_bank || config.account);
          this.withdrawFields = resolveWithdrawFields(config);
          this.accountInfo = parseWithdrawInfo(config.account && config.account.withdraw_info);
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
/deep/ .nav-bar {
  background: linear-gradient(120deg, #f3a3c4 0%, #c3a6f0 55%, #ffb894 100%) !important;
}
.container {
  min-height: 100%;
  padding-top: 2.875rem;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}
.container .main-content {
  margin: 0.9rem 4% 1rem;
  padding: 0.2rem 0.9rem;
  background: #fff;
  color: #4a3a5c;
  border-radius: 1.2rem;
  box-shadow: 0 0.4rem 1.1rem rgba(183, 156, 236, 0.16);
}
.account-card {
  margin: 0 4% 1rem;
  padding: 0.9rem 1rem;
  background: #fff;
  color: #4a3a5c;
  border-radius: 1.2rem;
  box-shadow: 0 0.4rem 1.1rem rgba(183, 156, 236, 0.16);
}
.account-card .account-title {
  padding-bottom: 0.35rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: #4a3a5c;
}
.account-card .account-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.6rem 0;
  font-size: 0.88rem;
  border-bottom: 1px solid #f6eef8;
}
.account-card .account-row:last-child {
  border-bottom: none;
}
.account-card .account-label {
  flex-shrink: 0;
  margin-right: 1rem;
  color: #969799;
}
.account-card .account-value {
  color: #4a3a5c;
  text-align: right;
  word-break: break-all;
}
.container .main-content .item{
  padding: 0.85rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  border-bottom: 1px solid #f6eef8;
}
.container .main-content .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container .main-content .item .right img{
  width: 90px;
}
.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .main-content .item .right .desc-cell-number, .container .main-content .item .right .desc{
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.avatarbox{
  padding: 15px;
  color: #000;
  height: 81%;
  background-color: #fff;
}
.avatarbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.avatarbox .content .van-image{
  width: 105px;
  height: 105px;
  margin: 2.5%;
  border-radius: 50%;
}
.avatarbox .content{
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.avatarbox .content .choose{
  width: 95px;
  height: 95px;
  border: 6px solid #e6c3a1;
}
</style>
